import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JournalModel } from '@ov-suite/models-warehouse';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { LoadManagementDataService } from '../../load-management.data.service';

@Component({
  selector: 'ov-suite-load-management-journal-history-modal',
  templateUrl: './load-management-journal-history-modal.component.html',
  styleUrls: ['./load-management-journal-history-modal.component.scss'],
})
export class LoadManagementJournalHistoryModalComponent implements OnInit {
  @Input() containerId: number;

  @Input() containerLabel = 'Container History';

  readonly displayedColumns: string[] = ['date', 'type', 'action', 'change', 'productSku', 'fromLocation', 'toLocation', 'description', 'responsibleUser'];

  dataSource = new MatTableDataSource<JournalModel>([]);

  totalCount = 0;

  pageSize = 10;

  pageIndex = 0;

  loading = false;

  constructor(
    private readonly loadManagementDataService: LoadManagementDataService,
    public readonly activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    void this.fetchData();
  }

  async fetchData(pageIndex = this.pageIndex, pageSize = this.pageSize): Promise<void> {
    if (!this.containerId) {
      this.totalCount = 0;
      this.dataSource.data = [];
      return;
    }

    this.loading = true;
    try {
      const response = await this.loadManagementDataService.getJournalHistory(this.containerId, pageSize, pageIndex * pageSize);
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.totalCount = response?.totalCount ?? 0;
      this.dataSource.data = response?.data ?? [];
    } finally {
      this.loading = false;
    }
  }

  onPageChange(event: PageEvent): void {
    void this.fetchData(event.pageIndex, event.pageSize);
  }

  formatUser(journal: JournalModel): string {
    return [journal?.responsibleUser?.firstName, journal?.responsibleUser?.lastName].filter(Boolean).join(' ') ||
      journal?.responsibleUser?.username ||
      '';
  }

  close(): void {
    this.activeModal.close();
  }
}
